import { render, staticRenderFns } from "./gd-dlysjg-locate-historys.vue?vue&type=template&id=179feb32&scoped=true"
import script from "./gd-dlysjg-locate-historys.vue?vue&type=script&lang=js"
export * from "./gd-dlysjg-locate-historys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179feb32",
  null
  
)

export default component.exports